export default __webpack_public_path__ + "static/profImg-88037ae98122fd3ef2cc90a7795f795e.png";